<template>
    <div class="main">
        <Spin fix v-if="loading"></Spin>
        <e-charts v-else :options="options" autoresize />
    </div>
</template>

<script>
import LineMixin from '@/views/common/m-chart-line'
import { nearInComeStatistic } from '@/api/ems-stats'
import dayjs from 'dayjs'
import { ymd } from '_u/helper'
export default {
    mixins: [LineMixin],
    data() {
        return {
            xList: [],
            seriesListOffline: [],
            seriesListOnline: [],
            loading: false,
        }
    },
    computed: {
        options() {
            return {
                title: {
                    text: '最近7天收入',
                    left: 14,
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    },
                },
                legend: {
                    data: ['线下支付', '线上支付'],
                    bottom: 15,
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.xList,
                    axisTick: {
                        interval: 0,
                        length: 5,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#aaa',
                        },
                    },
                },
                yAxis: {
                    name: '单位：元',
                    type: 'value',
                    nameTextStyle: {
                        color: 'rgb(153, 153, 153)',
                        fontSize: 12,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#aaa',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                },
                series: [
                    {
                        name: '线下支付',
                        type: 'line',
                        data: this.seriesListOffline,
                        symbol: 'circle',
                        color: ['rgb(255,150,0)'],
                    },
                    {
                        name: '线上支付',
                        type: 'line',
                        data: this.seriesListOnline,
                        symbol: 'circle',
                        color: ['#F29494'],
                    },
                ],
            }
        },
    },
    created() {
        this.loading = true
        nearInComeStatistic().then((res) => {
            let list = res.data.list
            let newXlist = []

            list.forEach((v) => {
                v.amount /= 100
                v.date = dayjs(v.date).format('MM-DD')
            })

            for (let i = 6; i >= 0; i--) {
                newXlist.push(dayjs().subtract(i, 'day').format('MM-DD'))
            }

            let seriesListOffline = []
            let seriesListOnline = []
            newXlist.forEach((m) => {
                const Online = list.find(
                    (v) => m === v.date && v.feeOnline === '1'
                ) || { amount: 0 }
                const Offline = list.find(
                    (v) => m === v.date && v.feeOnline === '2'
                ) || { amount: 0 }

                seriesListOnline.push(Online.amount)
                seriesListOffline.push(Offline.amount)
            })

            this.xList = newXlist
            this.seriesListOffline = seriesListOffline
            this.seriesListOnline = seriesListOnline
            this.loading = false
        })
    },
}
</script>

<style lang="less" scoped>
.main {
    width: 100%;
    height: 100%;
    padding-left: 20px;
    position: relative;
}
</style>
